import { PARTNERS, STAR_ICON } from "../../constants/HomeConstant";

const Collaborator = () => {
  return (
    <div className="home3-partner-area" id="home3-partner-area">
      <div className="container-fluid">
        <div className="row g-4">
          <div className="col-lg-3">
            <div className="partner-title">
              <h3>Our Collaborators</h3>
            </div>
          </div>
          <div className="col-lg-9">
            <div className="partner-wrapper">
              <div className="marquee_text">
                <div className="marquee_content">
                  {PARTNERS.map((partnerName, index) => (
                    <div key={index} className="marquee_item">
                      <img src={STAR_ICON} alt="star" className="star" />
                      <span>{partnerName}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Collaborator;
